import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';


const initialState = {
    proposalInventories: {},
};

const proposalInventorySlice = createSlice({
    name: 'proposalList',
    initialState,
    reducers: {
        
        addProposalInventories(state, action) {
           state.proposalInventories = action.payload;
        },
        emptyProposalInventories(state,action){
            state.proposalInventories = {};
        }
    },
});

// Export action creators
export const {
    addProposalInventories,
    emptyProposalInventories
} = proposalInventorySlice.actions;

// Reducer
export default proposalInventorySlice.reducer;

 